import { motion, useReducedMotion } from "framer-motion";
import { type FC, useId } from "react";
import { HALLOWEEN } from "@/theme/tokens";
import { PUMPKIN_BODY_PATH as BODY, PUMPKIN_STEM_PATH, PUMPKIN_VIEW_HEIGHT as VIEW_HEIGHT, PUMPKIN_VIEW_WIDTH as VIEW_WIDTH } from "./halloweenShapes";

const FILL_SECONDS = 1.2;

/** A pumpkin that fills with orange and empties again, its face glowing on top. */
export const PumpkinFillLoader: FC<{ dataTestId?: string }> = ({ dataTestId }) => {
	const reduceMotion = useReducedMotion();
	const clipId = `${useId().replaceAll(":", "")}-pumpkin`;
	return (
		<svg
			data-testid={dataTestId}
			aria-hidden
			width={HALLOWEEN.SIZE.PUMPKIN_WIDTH}
			height={(HALLOWEEN.SIZE.PUMPKIN_WIDTH * VIEW_HEIGHT) / VIEW_WIDTH}
			viewBox={`0 0 ${VIEW_WIDTH} ${VIEW_HEIGHT}`}
		>
			<defs>
				<clipPath id={clipId}>
					<path d={BODY} />
				</clipPath>
			</defs>
			<path d={PUMPKIN_STEM_PATH} fill="none" stroke={HALLOWEEN.STEM} strokeWidth={5} strokeLinecap="round" />
			<path d={BODY} fill={HALLOWEEN.PUMPKIN_EMPTY} />
			<g clipPath={`url(#${clipId})`}>
				<motion.rect
					x={0}
					width={VIEW_WIDTH}
					height={VIEW_HEIGHT}
					fill={HALLOWEEN.PUMPKIN}
					initial={{ y: reduceMotion ? 0 : VIEW_HEIGHT }}
					animate={reduceMotion ? undefined : { y: [VIEW_HEIGHT, 0] }}
					transition={{ duration: FILL_SECONDS, repeat: Number.POSITIVE_INFINITY, repeatType: "reverse", ease: [0.6, 0, 0.3, 1] }}
				/>
			</g>
			<path
				d="M26 36 L33 30 L37 39 Z M58 36 L51 30 L47 39 Z M24 50 Q42 62 60 50 L55 52 L52 48 L47 54 L42 49 L37 54 L32 48 L29 52 Z"
				fill={HALLOWEEN.CANDY_YELLOW}
			/>
		</svg>
	);
};
